<template>
	<!-- <pre>		{{  }}</pre> -->
	<div class="card">
		<!-- //? Loading -->
		<div class="card-body" v-if="projectStore.loading[`getProject-${projectId}`]">
			<!-- <div class="flex justify-center"> -->
			<div class="loading"></div>
			<!-- </div> -->
		</div>

		<!-- //? NO PROJECT FOUND -->
		<div class="card-body" v-else-if="!currentProject?._id">
			<div role="alert" class="alert alert-error alert-soft mx-auto max-w-lg">
				<TriangleAlert class="" :size="24" />
				<div>
					<span class="font-bold">{{ _tr('project.noProjectFound') }}:&nbsp;</span>
					<code class="font-bold">...#{{ projectId?.slice(-4) }}</code>
				</div>
			</div>
		</div>
		<div class="card-bod" v-else-if="currentProject?._id">
			<!-- :style="{
				'background-image': `url(${currentProject?.blobImage})`,
				'background-size': 'cover',
				'background-position': 'center',
				'background-color': 'rgba(255,255,255,0.7)'
			}" -->
			<div class="flex justify-between backdrop-blur" v-if="currentProject._id">
				<h2 class="card-title flex items-center gap-2 p-6 text-xl">
					<PinButton kind="project" :id="currentProject._id" />
					<StatusLight type="project" :_id="currentProject._id" />
					<span>{{ currentProject.name }}</span>
				</h2>

				<!-- <div class="m-1 mr-6 flex items-center justify-center overflow-hidden rounded-2xl">
					<img :src="currentProject.blobImage" alt="" class="h-20 w-auto" />
				</div> -->
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { computed } from 'vue'
	import { _translations } from './_translations'
	import { useI18n } from 'vue-i18n'
	import { ILocation } from '@/stores/location.store'
	import { TriangleAlert } from 'lucide-vue-next'
	import { useBaseStore } from '@/stores/base.store'
	import StatusLight from '@/components/StatusLight.vue'
	import PinButton from '@/components/common/PinButton.vue'
	import { useProjectStore } from '@/stores/projects.store'

	const { t: _tr } = useI18n(_translations)
	const projectStore = useProjectStore()
	const baseStore = useBaseStore()
	const currentProject = computed<ILocation | null>(() => projectStore.currentProject || null)
	const projectId = computed<string | null>(() => baseStore.getActiveIds.projectId || null)
</script>
